exports.f = {}.propertyIsEnumerable;



/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/~/core-js/library/modules/_object-pie.js
 ** module id = 229
 ** module chunks = 0
 **/